<template>
  <div class="dialog-wrap">
    <el-dialog
      title="申请详情"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      @close="handleClose"
    >
      <div class="order-wrap">
        <div
          class="card-wrap"
          v-if="arrayData.length"
        >
          <div class="inner">
            <div class="title">院校专业信息</div>
            <div class="info-wrap">
              <div class="info-row">
                <div class="label">报考院校：</div>
                <div class="value">{{ result.college_name}}</div>
              </div>
            </div>
            <div class="info-wrap">
              <div class="info-row">
                <div class="label">报考专业：</div>
                <div class="value">({{result.major_code}}){{ result.major_name}}</div>
              </div>
            </div>
          </div>
          <div
            class="inner"
            v-if="arrayData.filter((v)=>{ return v.year == '2019' }).length"
          >
            <div class="title">2019年</div>
            <div
              class="info-wrap"
              v-for="(item,index) in arrayData.filter((v)=>{ return v.year == '2019' })"
              :key="index"
            >
              <div class="info-row">
                <div class="label">{{item.param_name}}：</div>
                <div class="value">{{ item.content_text || "--" }}</div>
              </div>
            </div>
          </div>
          <div
            class="inner"
            v-if="arrayData.filter((v)=>{ return v.year == '2020' }).length"
          >
            <div class="title">2020年</div>
            <div
              class="info-wrap"
              v-for="(item,index) in arrayData.filter((v)=>{ return v.year == '2020' })"
              :key="index"
            >
              <div class="info-row">
                <div class="label">{{item.param_name}}：</div>
                <div class="value">{{ item.content_text || "--" }}</div>
              </div>
            </div>
          </div>
          <div
            class="inner"
            v-if="arrayData.filter((v)=>{ return v.year == '2021' }).length"
          >
            <div class="title">2021年</div>
            <div
              class="info-wrap"
              v-for="(item,index) in arrayData.filter((v)=>{ return v.year == '2021' })"
              :key="index"
            >
              <div class="info-row">
                <div class="label">{{item.param_name}}：</div>
                <div class="value">{{ item.content_text || "--" }}</div>
              </div>
            </div>
          </div>
          <div
            class="inner"
            v-if="arrayData.filter((v)=>{ return v.year == '2022' }).length"
          >
            <div class="title">2022年</div>
            <div
              class="info-wrap"
              v-for="(item,index) in arrayData.filter((v)=>{ return v.year == '2022' })"
              :key="index"
            >
              <div class="info-row">
                <div class="label">{{item.param_name}}：</div>
                <div class="value">{{ item.content_text || "--" }}</div>
              </div>
            </div>
          </div>
          <div class="inner">
            <div class="title">是否推荐报考及理由：</div>
            <div class="info-wrap">
              <div class="info-row">

                <div class="value">{{ result.additional}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
        v-if="result.status==0"
      >
        <el-button
          type="danger"
          @click="openrefuseDialog()"
        >驳 回</el-button>
        <el-button
          type="primary"
          @click="handleApply('approve')"
        >通 过</el-button>
      </div>
      <el-dialog
        title="拒绝理由"
        :close-on-click-modal="false"
        :visible.sync="refuseDialog"
        @close="refuseDialog=false"
        :modal-append-to-body="false"
        :modal="false"
        width="500px"
      >
        <el-input
          type="textarea"
          placeholder="请输入内容"
          v-model="refuse_reson"
          :rows="5"
        >
        </el-input>
        <div
          slot="footer"
          class="dialog-footer"
        >
          <el-button @click="refuseDialog=false">取 消</el-button>
          <el-button
            type="primary"
            @click="handleApply('reject')"
          >确 定</el-button>
        </div>
      </el-dialog>
    </el-dialog>
  </div>
</template>


<script>
import { contentapplyOne, applyreject, applyapprove } from '@/api/query'
import UEeditor from "@/components/UEeditor.vue"


export default {
  components: {
    UEeditor
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    content: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      result: {},
      arrayData: [],
      rules: {},
      refuseDialog: false,
      refuse_reson: "",
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    },
    content(val) {
      if (val) {
        this.fetchDetail(val.id)
      }
    }
  },
  methods: {
    fetchDetail(id) {
      contentapplyOne({ id }).then((res) => {
        this.result = res
        this.arrayData = res.contents
      })
    },

    handleClose() {
      this.refuse_reson = ""
      this.$emit('close')
    },
    openrefuseDialog() {
      this.refuseDialog = true
    },
    handleApply(method) {
      switch (method) {
        case "approve":
          applyapprove({ user_apply_id: this.result.id }).then((res) => {
            this.$message.success(`通过成功`)
            this.handleClose()
            this.$emit('submit')
          })
          break;
        case "reject":
          if (!this.refuse_reson) {
            this.$message.error(`请填写拒绝理由`)
            return
          }
          applyreject({ user_apply_id: this.result.id, refuse_reson: this.refuse_reson }).then((res) => {
            this.$message.success(`驳回成功`)
            this.handleClose()
            this.refuseDialog = false
            this.$emit('submit')
          })
          break;
        default:
          break;
      }
    }
  }
}
</script>

<style lang="less" scoped>
.dialog-wrap {
  .order-wrap {
    display: flex;
    flex-direction: column;
    .wrap-item {
      margin: 20px 40px 0 40px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }
  }
  .card-wrap {
    width: 100%;
    padding: 5px;

    .inner {
      min-height: 100px;
      border: 1px dashed #ccc;
      border-radius: 6px;
      padding: 5px 5px 10px;
      margin-bottom: 16px;
    }
    .title {
      font-size: 14px;
      font-weight: bold;
    }
    .info-wrap {
      margin-top: 15px;
    }
    .info-row {
      display: flex;
      align-items: center;
      font-size: 13px;

      & + .info-row {
        margin-top: 10px;
      }

      .label {
        width: 120px;
        text-align: right;
        color: #666;
      }
      .goods-name-value {
        margin-left: 10px;
        .goods-name-span {
          display: block;
          margin-bottom: 5px;
        }
      }
      .value {
        flex: 1;
        color: #333;
        margin-left: 10px;
        line-height: 20px;
      }
      img {
        max-width: 80px;
      }
    }
  }

  /deep/ .el-dialog__body {
    padding-top: 10px;
  }
  .result {
    margin-top: 10px;
  }
  .footer {
    margin-top: 10px;
  }
}
</style>
